import { ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

// ng-otp-input has no autofocus option: once the dialog finished opening, focus the first digit.
// The dialogs are opened with autoFocus: false so Material does not move the focus elsewhere.
export function focusFirstOtpInput(dialogRef: MatDialogRef<unknown>, host: ElementRef<HTMLElement>): void {
  dialogRef.afterOpened().subscribe(() => {
    host.nativeElement.querySelector<HTMLInputElement>('ng-otp-input input')?.focus();
  });
}
